import { render, staticRenderFns } from "./SubstanceEditorStructured.vue?vue&type=template&id=609d1ffc&"
import script from "./SubstanceEditorStructured.vue?vue&type=script&lang=js&"
export * from "./SubstanceEditorStructured.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceEditorStructured.vue?vue&type=style&index=0&id=609d1ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports